import { DAPI_HOST } from '../../config';

export const getAppInteractionsUrl = () => `${DAPI_HOST}/v1/app-interactions`;
